import script from "./BaseSchedule.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSchedule.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__